export const navLinks = [
  { label: '首页', href: '/' },
  { label: '每日大赛', href: '/category/daily-contest' },
  { label: '明星塌房', href: '/category/celebrity-scandal' },
  { label: '博主反差', href: '/category/blogger-reverse' },
  { label: '网红黑料', href: '/category/influencer-expose' },
  { label: '吃瓜现场', href: '/category/live-gossip' },
];

export const footerInfo = {
  brandName: '51黑料网',
  description: '聚合全网最新黑料、每日大赛、吃瓜爆料内容。实时追踪娱乐圈动态，第一时间为你带来博主反差、明星塌房等独家猛料。吃瓜，我们是认真的。',
  address: {
    label: '地址',
    lines: ['北京市朝阳区光华路', 'SOHO现代城A座1208室'],
  },
  phone: {
    label: '电话',
    lines: ['+86 400-888-5151'],
  },
  email: {
    label: '邮箱',
    lines: ['contact@51heiliao.com'],
  },
  socialLinks: [
    { icon: 'ri-weibo-line', href: '#', label: '微博' },
    { icon: 'ri-wechat-line', href: '#', label: '微信' },
    { icon: 'ri-tiktok-line', href: '#', label: '抖音' },
    { icon: 'ri-bilibili-line', href: '#', label: 'B站' },
  ],
  bottomLinks: [
    { label: '隐私政策', href: '/privacy' },
    { label: '用户协议', href: '/terms' },
    { label: '联系我们', href: '/about' },
  ],
};

export const aboutData = {
  title: '关于51黑料网',
  subtitle: '全网最全吃瓜平台',
  intro: '51黑料网成立于2022年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为吃瓜群众提供最新、最全、最真实的黑料爆料内容。无论是明星塌房、网红翻车，还是博主反差、圈内潜规则，51黑料网都在第一时间为你呈现。',
  stats: [
    { value: '5000万+', label: '月活跃用户' },
    { value: '120万+', label: '累计爆料' },
    { value: '98%', label: '用户满意度' },
    { value: '200+', label: '合作媒体' },
  ],
  values: [
    { title: '真实可靠', description: '严格审核每一条爆料信息，确保内容真实性，杜绝虚假消息。' },
    { title: '快速及时', description: '7x24小时全天候监测，重大爆料事件15分钟内上线。' },
    { title: '全面覆盖', description: '涵盖娱乐圈、网红圈、直播圈等多领域，无死角追踪。' },
    { title: '用户至上', description: '始终以用户体验为核心，提供流畅的阅读和互动体验。' },
  ],
  reputation: {
    title: '用户口碑',
    reviews: [
      { name: '吃瓜群众小王', role: '资深用户', content: '自从关注了51黑料网，再也不怕错过任何瓜了！信息更新快，内容真实可靠，推荐给所有爱吃瓜的朋友！' },
      { name: '娱乐达人Lily', role: '微博大V', content: '作为娱乐圈从业者，我每天必刷51黑料网。很多独家爆料比同行快至少半天，信息准确度也很高。' },
      { name: '追星少女小美', role: '忠实粉丝', content: '51黑料网是我每天的快乐源泉！每日大赛的评论区比内容还精彩，吃瓜氛围一级棒！' },
    ],
  },
  contact: {
    title: '联系我们',
    description: '如果你有独家爆料线索或商务合作需求，欢迎通过以下方式联系我们。我们会对爆料人信息严格保密。',
    email: 'tips@51heiliao.com',
    phone: '400-888-5151',
    address: '北京市朝阳区光华路SOHO现代城A座1208室',
    wechat: '51heiliao_official',
  },
};